<template>
  <v-dialog v-model="visible" max-width="1200px">
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">{{ nombreItem }}</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-row>
          <v-col v-for="(item, indice) in listado" :key="indice" cols="12" md="6" lg="4" class="pa-0">
            <ListadoItem :nombreCampo="item.nombre" :valorCampo="item.valor" />
          </v-col>
        </v-row>

        <v-form>
          <v-row>
            <v-col cols="10">
              <vue-select
                v-model="item.planPagoUniversidadId"
                class="style-chooser"
                placeholder="Seleccione un Plan de Pago"
                :options="planesPagosUniversidades"
                label="nombre"
                :append-to-body="true"
                :reduce="(option) => option.id"
                clearable
                :disabled="planesPagosUniversidades.length == 0 || !!item.planPagoUniversidad || enviando">
                <template #option="{ nombre, planesPagosConceptosUniversidades }">
                  <div style="padding-bottom: 0.5rem">
                    <strong style="display: block; font-size: 1.125rem">{{ nombre }}</strong>

                    <TablaPlanesPagosConceptosUniversidades
                      :planesPagosConceptosUniversidades="planesPagosConceptosUniversidades" />
                  </div>
                </template>
              </vue-select>

              <small v-for="error in errores.planPagoUniversidadId" :key="error" class="d-block text-danger">
                {{ error }}
              </small>
            </v-col>

            <v-col cols="2">
              <v-btn
                color="primary"
                :disabled="planesPagosUniversidades.length == 0 || !!item.planPagoUniversidad || enviando"
                :loading="enviando"
                @click="$refs.confirmacionRef.abrir()">
                <v-icon left>mdi-content-save</v-icon>

                Establecer
              </v-btn>
            </v-col>

            <v-col cols="12" v-if="!!item.planPagoUniversidad">
              <TablaPlanesPagosConceptosUniversidades
                :planesPagosConceptosUniversidades="
                  planPagoUniversidadSeleccionado?.planesPagosConceptosUniversidades || []
                " />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click.prevent="cerrar"> Cerrar </v-btn>
      </v-card-actions>
    </v-card>

    <ConfirmacionAccion
      ref="confirmacionRef"
      :titulo="confirmacion.titulo"
      :mensaje="confirmacion.mensaje"
      :realizandoAccion="confirmacion.realizandoAccion"
      @aceptar="confirmacion.fnAceptar" />
  </v-dialog>
</template>

<script>
import programaUniversidadMixin from '../mixins/programa-universidad.mixin';
import PlanPagoUniversidadService from '../services/plan-pago-universidad.service';
import ProgramaUniversidadService from '../services/programa-universidad.service';
import TablaPlanesPagosConceptosUniversidades from './TablaPlanesPagosConceptosUniversidades.vue';
import ConfirmacionAccion from '../components/ConfirmacionAccion.vue';

export default {
  name: 'ModalFormEstablecerPlanPagoProgramaUniversidad',
  mixins: [programaUniversidadMixin],
  components: {
    TablaPlanesPagosConceptosUniversidades,
    ConfirmacionAccion,
  },
  watch: {
    'item.planPagoUniversidadId': function () {
      this.errores.planPagoUniversidadId = [];
    },
    enviando: function (value) {
      this.confirmacion.realizandoAccion = value;
    },
  },
  computed: {
    listado() {
      return [
        { nombre: 'Código', valor: this.item.codigo },
        { nombre: 'Nombre Programa', valor: this.item.programaNombre },
        { nombre: 'Área', valor: this.item.areaUniversidad?.nombre },
        { nombre: 'Tipo', valor: this.item.categoriaUniversidad?.nombre },
        {
          nombre: 'Gestión / Versión / Grupo',
          valor: `${this.item.gestion} / ${this.item.version} / ${this.item.grupo || '-'}`,
        },
        { nombre: 'Resol. Aprob. Univ.', valor: this.item.resolucionAprobacionUniversidad },
        { nombre: 'Sede Universidad', valor: this.item.sedeUniversidad?.nombre },
        { nombre: 'Estado', valor: this.item.estado?.toUpperCase() },
        { nombre: 'Plan de Pago', valor: this.item.planPagoUniversidad?.nombre || 'No asignado' },
      ];
    },
    sedeUniversidad() {
      return this.item.sedeUniversidad;
    },
    planPagoUniversidadSeleccionado() {
      return this.planesPagosUniversidades.find(
        (planPagoUniversidad) => planPagoUniversidad.id === this.item.planPagoUniversidadId,
      );
    },
  },
  data() {
    return {
      visible: false,
      item: this.generarObjetoFormRegistrar(),
      nombreItem: 'Programa Universidad',
      planesPagosUniversidades: [],
      confirmacion: {
        titulo: 'Establecer Plan de Pago',
        mensaje: '¿Está seguro que desea establecer el Plan de Pago seleccionado? Esta acción no se puede deshacer.',
        realizandoAccion: false,
        fnAceptar: () => this.establecerPlanPagoUniversidad(),
      },
    };
  },
  methods: {
    abrir(data = null) {
      this.item = this.generarObjetoFormEditar(data);

      Promise.all([this.obtenerPlanesPagosUniversidades()]).then(() => {
        this.visible = true;
      });
    },
    cerrar() {
      this.visible = false;
    },
    async obtenerPlanesPagosUniversidades() {
      this.planesPagosUniversidades = [];

      if (!this.sedeUniversidad) {
        return;
      }

      const params = {
        universidadId: this.sedeUniversidad.universidadId,
      };

      await this.obtenerDatosMixin(PlanPagoUniversidadService.findAll, 'planesPagosUniversidades', params);
    },
    async establecerPlanPagoUniversidad() {
      await this.guardarDatosMixin(
        () => {},
        ProgramaUniversidadService.establecerPlanPagoUniversidad,
        this.accionesCrud.EDITAR,
        this.item,
        'Plan de Pago establecido con éxito.',
        () => {
          this.cerrar();
          this.$emit('actualizarListado');
        },
        (errores) => {
          this.errores = errores;
        },
      );
    },
  },
};
</script>